import { AccountsVisibility } from "@services/user/types";
import { CapabilitiesType } from "./types";

export const capabilities: CapabilitiesType[] = [
  {
    label: "None",
    permissions: {
      adminAccountsVisibility: AccountsVisibility.HomeAccountOnly,
      assignProducer: false,
      assignRolesToUsers: false,
      linkAccountsToUsers: false,
      produceMeetings: false,
      allowBulkChanges: false,
      controlDevices: false,
      assignAuthorToUsers: false,
      accountConfiguration: "NoAccess",
      accounts: "NoAccess",
      analyticsReports: "NoAccess",
      attachments: "NoAccess",
      devices: "NoAccess",
      globalConfiguration: "NoAccess",
      locations: "NoAccess",
      meetings: "NoAccess",
      meetingsElogsAndRevisions: "NoAccess",
      reports: "NoAccess",
      rolesCapabilities: "NoAccess",
      rooms: "NoAccess",
      tickets: "NoAccess",
      users: "NoAccess",
      admin: false,
    },
  },
  {
    label: "Full Access (Linked Accounts from Tenant only)",
    permissions: {
      adminAccountsVisibility: AccountsVisibility.HomeTenantAccounts,
      assignProducer: true,
      assignRolesToUsers: true,
      linkAccountsToUsers: true,
      produceMeetings: true,
      allowBulkChanges: true,
      controlDevices: true,
      assignAuthorToUsers: true,
      accountConfiguration: "FullAccess",
      accounts: "FullAccess",
      analyticsReports: "FullAccess",
      attachments: "FullAccess",
      devices: "FullAccess",
      globalConfiguration: "NoAccess",
      locations: "FullAccess",
      meetings: "FullAccess",
      meetingsElogsAndRevisions: "FullAccess",
      reports: "FullAccess",
      rolesCapabilities: "NoAccess",
      rooms: "FullAccess",
      tickets: "FullAccess",
      users: "FullAccess",
      admin: true,
    },
  },
  {
    label: "Full Access (Home Account only)",
    permissions: {
      adminAccountsVisibility: AccountsVisibility.HomeAccountOnly,
      assignProducer: false,
      assignRolesToUsers: false,
      linkAccountsToUsers: false,
      assignAuthorToUsers: false,
      produceMeetings: false,
      allowBulkChanges: true,
      controlDevices: true,
      accountConfiguration: "FullAccess",
      accounts: "NoAccess",
      analyticsReports: "FullAccess",
      attachments: "FullAccess",
      devices: "FullAccess",
      globalConfiguration: "NoAccess",
      locations: "FullAccess",
      meetings: "FullAccess",
      meetingsElogsAndRevisions: "NoAccess",
      reports: "FullAccess",
      rolesCapabilities: "NoAccess",
      rooms: "FullAccess",
      tickets: "FullAccess",
      users: "FullAccess",
      admin: true,
    },
  },
  {
    label: "Can View Everything (Linked Accounts from Tenant only)",
    permissions: {
      adminAccountsVisibility: AccountsVisibility.HomeTenantAccounts,
      assignProducer: false,
      assignRolesToUsers: false,
      linkAccountsToUsers: false,
      produceMeetings: false,
      allowBulkChanges: false,
      controlDevices: false,
      assignAuthorToUsers: false,
      accountConfiguration: "ViewOnly",
      accounts: "ViewOnly",
      analyticsReports: "ViewOnly",
      attachments: "ViewOnly",
      devices: "ViewOnly",
      globalConfiguration: "NoAccess",
      locations: "ViewOnly",
      meetings: "ViewOnly",
      meetingsElogsAndRevisions: "ViewOnly",
      reports: "ViewOnly",
      rolesCapabilities: "NoAccess",
      rooms: "ViewOnly",
      tickets: "ViewOnly",
      users: "ViewOnly",
      admin: true,
    },
  },
  {
    label: "Can View Everything (Home Account only)",
    permissions: {
      adminAccountsVisibility: AccountsVisibility.HomeAccountOnly,
      assignProducer: false,
      assignRolesToUsers: false,
      linkAccountsToUsers: false,
      produceMeetings: false,
      allowBulkChanges: false,
      controlDevices: false,
      assignAuthorToUsers: false,
      accountConfiguration: "ViewOnly",
      accounts: "NoAccess",
      analyticsReports: "ViewOnly",
      attachments: "ViewOnly",
      devices: "ViewOnly",
      globalConfiguration: "NoAccess",
      locations: "ViewOnly",
      meetings: "ViewOnly",
      meetingsElogsAndRevisions: "ViewOnly",
      reports: "ViewOnly",
      rolesCapabilities: "NoAccess",
      rooms: "ViewOnly",
      tickets: "ViewOnly",
      users: "ViewOnly",
      admin: true,
    },
  },
  {
    label: "Custom",
    permissions: {
      admin: true,
    },
  },
];
